import React from 'react';
import { useSelector } from 'react-redux';
import { cloneDeep } from 'lodash-es';

import { selectMenuRatio } from './reducer';
import styles from './MenuCategoryRatio.module.css';

const MenuCategoryRatio = ({ menuRatio, onRatioChange }) => {

  const currMenuRatio = useSelector(selectMenuRatio);

  const handleChange = evt => {
    const id = parseInt(evt.target.name);
    const newMenuRatio = menuRatio.map(r => {
      if (r.menuCategoryId === id) {
        const newRatio = cloneDeep(r);
        newRatio.ratio = parseInt(evt.target.value);
        return newRatio;
      }
      else {
        return r;
      }
    });
    onRatioChange(newMenuRatio);
  };

  return (
    <div className={styles.root}>
      <div className={styles.ratioList}>
        <div className={styles.title}>추천 구성비</div>
        {menuRatio.map((ratio, i) => (
        <div
          key={i}
          className={styles.ratioRow}>
          <div className={styles.ratioTitle}>{ratio.menuCategoryName}</div>
          <div className={styles.ratioValue}>
            <input
              type='number'
              className={styles.input}
              name={ratio.menuCategoryId}
              value={ratio.ratio}
              onChange={handleChange}
            />
          </div>
        </div>
        ))}
      </div>
      <div className={styles.ratioList}>
        <div className={styles.title}>현재 구성비</div>
        {currMenuRatio.map((ratio, i) => (
        <div
          key={i}
          className={styles.ratioRow}>
          <div className={styles.ratioTitle}>{ratio.menuCategoryName}</div>
          <div className={styles.ratioValue}>{ratio.ratio}</div>
        </div>
        ))}
      </div>
    </div>
  );
}

export default MenuCategoryRatio;